import { Dispatch, SetStateAction } from "react";
import { ReviewTab } from "src/config/reviewSystemData";

export default function handleReviewStepChange(
  step: number,
  setReviewTabs: Dispatch<SetStateAction<ReviewTab[]>>
) {
  setReviewTabs((prevTabs) => {
    const updatedTabs: ReviewTab[] = prevTabs.map((tab) => {
      if (tab.step < step) {
        return {
          ...tab,
          touched: true,
          current: false,
        };
      } else if (tab.step === step) {
        return {
          ...tab,
          touched: true,
          current: true,
        };
      } else {
        return {
          ...tab,
          current: false,
        };
      }
    });

    return updatedTabs;
  });
}
